import React from 'react'
import classnames from 'classnames'

import './AddressChip.css'

const AddressChip = props => {
  const { className, style, label, address, selected, onClick, onEdit } = props
  return (
    <div
      className={classnames('cookunity__address_chip', { selected }, className)}
      style={style}
      onClick={onClick}>
      {onEdit && (
        <div className="edit_container">
          <div className="edit_button">
            <span onClick={onEdit}>
              <i className="fas fa-pen" />
              Edit
            </span>
          </div>
        </div>
      )}

      <p className="label">{label}</p>
      <p className="address">{address}</p>
    </div>
  )
}

export default AddressChip



// WEBPACK FOOTER //
// ./src/components/AddressChip/AddressChip.jsx